// ラベル・件数・件数に応じた棒（同じグループ内の最大値に対する割合）を表示する。
export function StatBar ({ label, value, max, color }: { label: string, value: number, max: number, color: string }): React.ReactElement {
  const pct = max > 0 ? Math.min((value / max) * 100, 100) : 0
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 3 }}>
        <span style={{ fontSize: 11, color: 'var(--bp-panel-ink2)' }}>{label}</span>
        <span style={{
          fontSize: 11,
          fontWeight: 700,
          color: 'var(--bp-panel-ink)',
          fontVariantNumeric: 'tabular-nums'
        }}
        >{value}
        </span>
      </div>
      <div style={{ height: 4, background: 'rgba(255,255,255,.1)', borderRadius: 2 }}>
        <div style={{ width: `${pct}%`, height: '100%', background: color, borderRadius: 2 }} />
      </div>
    </div>
  )
}
